import React from 'react'
import { string, number, func, shape, object } from 'prop-types'
import { translate } from 'react-i18next'
import moment from 'moment'

import { Price } from '../ui/inputs/Price'

export const InvoiceItem = translate()(({ t, facture }) => {
  const { id, description, date, invoice, payment, quotation, price, by, refund } = facture
  return (
    <div key={id} className='box box--grey'>
      <div className='account__facture__infos'>
        <div className='account__facture__infos__title'>
          {
            refund
            ? <h2 className='account__facture__infos__title__date'>{t('common:visits:refund_of')} {moment.unix(date).format('DD/MM/YYYY')}</h2>
            : <h2 className='account__facture__infos__title__date'>{t('common:visits:visits_of')} {moment.unix(date).format('DD/MM/YYYY')}</h2>
          }
          <h2 className='account__facture__infos__title__price'><Price value={price} /></h2>
        </div>
        {
          by && by.length
          ? <div className='account__facture__infos__jardinier'>
            { `${t('common:visits:performed_by')} ${by.join(t('common:visits:performed_by_delimiter'))}`}
          </div>
          : ''
        }
        <p className='account__facture__infos__description'>
          { description }
        </p>
      </div>
      <div className='account__facture__actions'>
        { invoice ? <a className='btn--default btn--small' target='_blank' href={invoice.path}>{t('common:buttons:see_invoice')}</a> : '' }
        { invoice ? <a className='btn--default btn--small' target='_blank' href={invoice.path + '&download=true'}>{t('common:buttons:download_invoice')}</a> : '' }
        { payment ? <a className='btn--default btn--small' target='_blank' href={payment.path}>{t('common:buttons:see_payment')}</a> : '' }
        { quotation ? <a className='btn--default btn--small' target='_blank' href={quotation.path}>{t('common:buttons:see_quotation')}</a> : '' }
      </div>
    </div>
  )
})

InvoiceItem.propTypes = {
  facture: shape({
    id: string,
    date: number,
    description: string,
    invoice: object,
    payment: object,
    quotation: object
  }),
  t: func
}



// WEBPACK FOOTER //
// ./src/components/customer/InvoiceItem.js